import { request } from 'root/common/request';
import url from './url';

export function getSkuForm(params, options) {
    return request({
        url: url.getSkuForm,
        method: 'GET',
        params,
        isNeedLoading: true,
        isNeedToken: false,
        ...options,
    });
}

export function getRechargeSuccessAccount(params, options) {
    return request({
        url: url.getRechargeSuccessAccount,
        method: 'GET',
        params,
        isNeedLoading: false,
        isNeedToken: false,
        ...options,
    });
}

// 删除充值账号
export function hiddenSuccessAccount(data) {
    return request({
        url: url.hiddenSuccessAccount,
        method: 'post',
        data,
        isNeedLoading: false,
        isNeedToken: true,
    });
}
